'use server'

import { apiRequest, ApiResponse } from '../request'

export interface CostCenterItem {
    id: number
    name: string
    code: string
    active: boolean
    parentId: number | null
    parent?: { id: number; name: string; code: string } | null
    children?: CostCenterItem[]
    _count?: { children: number }
    companyId: number
    createdAt: string
    updatedAt: string
}

export interface OrganizationUnit {
    id: number
    name: string
    tradingName: string | null
}

export interface CreateCostCenterData {
    name: string
    code?: string
    parentId?: number | null
}

export interface UpdateCostCenterData extends Partial<CreateCostCenterData> {
    active?: boolean
}

const BASE = 'financial/cost-centers'

export async function getCostCenters(): Promise<ApiResponse<CostCenterItem[]>> {
    return apiRequest<CostCenterItem[]>(BASE, {})
}

export async function getCostCenterTree(): Promise<ApiResponse<CostCenterItem[]>> {
    return apiRequest<CostCenterItem[]>(`${BASE}/tree`, {})
}

export async function getCostCenterChildren(parentId: number): Promise<ApiResponse<CostCenterItem[]>> {
    return apiRequest<CostCenterItem[]>(`${BASE}/children/${parentId}`, {})
}

export async function searchCostCenters(query: string): Promise<ApiResponse<CostCenterItem[]>> {
    return apiRequest<CostCenterItem[]>(`${BASE}/search`, { params: { q: query } })
}

export async function getCostCenterNextCode(parentId?: number | null): Promise<ApiResponse<{ code: string }>> {
    const params: any = {}
    if (parentId) params.parentId = parentId
    return apiRequest<{ code: string }>(`${BASE}/next-code`, { params })
}

export async function getCostCenter(id: number): Promise<ApiResponse<CostCenterItem>> {
    return apiRequest<CostCenterItem>(`${BASE}/${id}`, {})
}

export async function createCostCenter(data: CreateCostCenterData): Promise<ApiResponse<CostCenterItem>> {
    return apiRequest<CostCenterItem>(BASE, { data }, 'post')
}

export async function updateCostCenter(id: number, data: UpdateCostCenterData): Promise<ApiResponse<CostCenterItem>> {
    return apiRequest<CostCenterItem>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deleteCostCenter(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${id}`, {}, 'delete')
}

export async function getOrganizationUnits(): Promise<ApiResponse<OrganizationUnit[]>> {
    return apiRequest<OrganizationUnit[]>(`${BASE}/organization-units`, {})
}
